import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "height100 d-flex flex-column justify-center align-center text-center"
}
const _hoisted_3 = { style: {"margin-bottom":"10px","color":"#EE6090","font-size":"16px"} }
const _hoisted_4 = {
  key: 1,
  class: "children-header d-flex"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "pa-1 today-wrapper" }
const _hoisted_9 = { class: "d-flex flex-column align-end" }
const _hoisted_10 = {
  class: "text-grey-darken-1 mb-1",
  style: {"font-size":"0.65rem"}
}
const _hoisted_11 = {
  key: 0,
  class: "badge d-flex justify-center align-center"
}
const _hoisted_12 = {
  key: 3,
  class: "d-flex justify-center pa-5"
}
const _hoisted_13 = {
  key: 4,
  class: "speech-bubble-wrapper"
}
const _hoisted_14 = { class: "speech-bubble speech-bubble-right-bottom" }
const _hoisted_15 = { class: "fab-wrapper" }
const _hoisted_16 = { class: "d-flex flex-column ga-3" }
const _hoisted_17 = { class: "text-h5 mb-1" }
const _hoisted_18 = { class: "text-caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_slide_y_reverse_transition = _resolveComponent("v-slide-y-reverse-transition")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_absence_modal = _resolveComponent("absence-modal")!
  const _component_invoice_modal = _resolveComponent("invoice-modal")!
  const _component_pickup_modal = _resolveComponent("pickup-modal")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.fetchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('home.loadingReleaseInfo')), 1),
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "#EE6090",
            size: "50"
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.fetchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (c) => {
            return (_openBlock(), _createElementBlock("div", {
              key: c.childId,
              class: "icon mr-2",
              onClick: ($event: any) => (_ctx.selectChild(c.childId))
            }, [
              _createElementVNode("img", {
                class: _normalizeClass({ active: c.childId === _ctx.selectedChildId }),
                src: _ctx.resolveChildImageUrl(c.imageUrl) || 'https://via.placeholder.com/240x180?text=Sample+Image+1'
              }, null, 10, _hoisted_6)
            ], 8, _hoisted_5))
          }), 128)),
          _createVNode(_component_v_btn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ path: '/child/add', name: 'ChildAdd' }))),
            color: "primary",
            variant: "outlined",
            icon: "mdi-plus",
            size: "60",
            class: "custom-plus-btn"
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.fetchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedsByDate, (fByDate) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "feed_wrapper no-scroll-bar",
              key: Object.keys(fByDate)[0]
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.formatFeedSectionDate(Object.keys(fByDate)[0])), 1)
              ]),
              _createVNode(_component_v_list, {
                density: "compact",
                lines: "three",
                class: "no-scroll-bar pa-0"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fByDate[Object.keys(fByDate)[0]], (f) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: f.feedId + f.body
                    }, [
                      _createVNode(_component_v_list_item, {
                        onClick: ($event: any) => (_ctx.clickFeed(f)),
                        class: "position-relative"
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_avatar, { class: "ml-2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_img, {
                                src: _ctx.resolveChildImageUrl(f.child?.imageUrl)
                              }, null, 8, ["src"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        append: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formatMinutes(f.createdAt)), 1),
                            (f.unReadCnt)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(f.unReadCnt), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, {
                            class: "font-weight-bold text-subtitle-1",
                            style: {"white-space":"pre-wrap"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formatFeedTitle(f)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_list_item_subtitle, {
                            class: "feed-subtitle text-subtitle-2 text-grey-darken-1",
                            style: {"white-space":"pre-wrap","max-height":"40px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formatFeedBody(f.body)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_v_divider)
                    ], 64))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ])), [
              [_vShow, fByDate[Object.keys(fByDate)[0]].length > 0]
            ])
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.fetchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_v_btn, {
            onClick: _ctx.fetchMoreFeed,
            color: "primary",
            variant: "text",
            loading: _ctx.isFetchMoreFeed
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('home.loadMore')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isNewInformation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('home.newAnnouncement')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_v_btn, {
        color: "primary",
        icon: "",
        size: "large",
        elevation: "4",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fab = !_ctx.fab))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.fab ? 'mdi-close' : 'mdi-plus'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_slide_y_reverse_transition, null, {
        default: _withCtx(() => [
          (_ctx.fab)
            ? _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                class: "fab-menu-card pa-0 mb-4",
                variant: "flat",
                elevation: "0",
                style: {"background-color":"transparent !important","backdrop-filter":"none !important","-webkit-backdrop-filter":"none !important","box-shadow":"none !important"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.SHOW_FAB_RELEASE_INFO)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          rounded: "pill",
                          size: "large",
                          variant: _ctx.isNewInformation ? 'flat' : 'outlined',
                          color: "primary",
                          class: "align-self-end",
                          style: _normalizeStyle({
                  minWidth: '0',
                  width: 'fit-content',
                  // 未読がある（isNewInformation）ときは指定なし（Vuetifyのprimaryが適用）、
                  // そうでないときは白背景を適用
                  backgroundColor: _ctx.isNewInformation ? '' : 'rgba(255, 255, 255, 1) !important',
                  // 文字色も同様に、未読時は白、それ以外は指定なし（outlinedのときはprimary色になる）
                  color: _ctx.isNewInformation ? 'white !important' : ''
                }),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.beforeOpenModal('information'); _ctx.fab = false})
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('home.fabReleaseInfo')), 1)
                          ]),
                          _: 1
                        }, 8, ["variant", "style"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_btn, {
                      rounded: "pill",
                      size: "large",
                      variant: "outlined",
                      color: "primary",
                      class: "align-self-end",
                      style: {"min-width":"0","width":"fit-content","background-color":"rgba(255, 255, 255, 1) !important"},
                      onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.beforeOpenModal('absence'); _ctx.fab = false})
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('home.fabAbsence')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      rounded: "pill",
                      size: "large",
                      variant: "outlined",
                      color: "primary",
                      class: "align-self-end",
                      style: {"min-width":"0","width":"fit-content","background-color":"rgba(255, 255, 255, 1) !important"},
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.beforeOpenModal('pickup'); _ctx.fab = false})
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('home.fabPickup')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })), [
                [_directive_click_outside, () => _ctx.fab = false]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isSelectChildDialog,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isSelectChildDialog) = $event)),
      width: "90%",
      "scroll-strategy": "none"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "pa-2",
          rounded: "lg",
          style: {"overflow":"hidden","min-height":"100px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list, { density: "compact" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectChildOpt, (child, i) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: i,
                    onClick: ($event: any) => (_ctx.openModal(child.childId, child.lastName + child.firstName)),
                    rounded: "md"
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_avatar, { border: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_img, {
                            src: _ctx.resolveChildImageUrl(child.imageUrl) || 'https://via.placeholder.com/150'
                          }, null, 8, ["src"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(child.lastName + child.firstName), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isAttendanceDialog,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isAttendanceDialog) = $event)),
      width: "300",
      "scroll-strategy": "none",
      attach: "main"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "pa-4 text-center",
          rounded: "xl"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _ctx.qrCode ?? undefined,
              class: "mb-4"
            }, null, 8, ["src"]),
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.selectedChildName), 1),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.t('home.qrBarcodeHint')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isAbsenceDialog,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isAbsenceDialog) = $event)),
      persistent: "",
      width: "500",
      "scroll-strategy": "none"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_absence_modal, {
          "is-open": _ctx.isAbsenceDialog,
          "child-id": _ctx.selectedChildId,
          onPosted: _ctx.fetchFeed,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isAbsenceDialog = false))
        }, null, 8, ["is-open", "child-id", "onPosted"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.SHOW_INVOICE_UI)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 5,
          modelValue: _ctx.isInvoiceDialog,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isInvoiceDialog) = $event)),
          persistent: "",
          width: "500"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_invoice_modal, {
              "is-open": _ctx.isInvoiceDialog,
              onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isInvoiceDialog = false))
            }, null, 8, ["is-open"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isPickupDialog,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isPickupDialog) = $event)),
      persistent: "",
      width: "500",
      "scroll-strategy": "none",
      attach: "main"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_pickup_modal, {
          "is-open": _ctx.isPickupDialog,
          "child-id": _ctx.selectedChildId,
          onPosted: _ctx.fetchFeed,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isPickupDialog = false))
        }, null, 8, ["is-open", "child-id", "onPosted"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}